const parseBoolean = (value) => {
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase();
        if (['true', '1', 'yes', 'y'].includes(normalized)) {
            return true;
        }
        if (['false', '0', 'no', 'n', ''].includes(normalized)) {
            return false;
        }
    }
    return Boolean(value);
};

const useLegacyCertificateBrief = parseBoolean(process.env.legacy_certificate_brief);

export { useLegacyCertificateBrief };
